interface AvailabilityPillProps {
  seats: number;
}

export const AvailabilityPill = ({ seats }: AvailabilityPillProps) => {
  const getColor = () => {
    if (seats <= 5) return 'bg-[#FEF2F2] text-[#EF4444] border-[#FEE2E2]';
    if (seats <= 15) return 'bg-[#FEF3C7] text-[#D97706] border-[#FDE68A]';
    return 'bg-[#DCFCE7] text-[#16A34A] border-[#BBF7D0]';
  };

  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border ${getColor()}`}
    >
      {seats} {seats === 1 ? 'asiento' : 'asientos'}
    </span>
  );
};
